import type { DataShape } from '../../services/fields';

export const PREFIX: keyof DataShape = 'notify';
